module.exports = __webpack_public_path__ + "assets/logo_circle.5f5b9030.svg";